import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaHome, FaArrowLeft, FaExclamationTriangle } from 'react-icons/fa';

const ErrorPage = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="error-page">
      <div className="container">
        <div className="row justify-content-center align-items-center min-vh-100">
          <div className="col-lg-6 col-md-8 col-sm-10">
            <div className="error-content text-center">
              {/* Error Icon */}
              <div className="error-icon mb-4">
                <FaExclamationTriangle className="error-triangle" />
              </div>
              
              {/* Error Code */}
              <div className="error-code mb-3">
                <h1 className="display-1 fw-bold">404</h1>
              </div>
              
              {/* Error Message */}
              <div className="error-message mb-4">
                <h2 className="h3 mb-3">Oops! Page Not Found</h2>
                <p className="lead mb-4">
                  The page you're looking for doesn't exist or has been moved. 
                  Don't worry, it happens to the best of us!
                </p>
              </div>
              
              {/* Action Buttons */}
              <div className="error-actions">
                <Link to="/" className="btn btn-primary btn-lg me-3 mb-2">
                  <FaHome className="me-2" />
                  Go Home
                </Link>
                <button 
                  onClick={goBack} 
                  className="btn btn-outline-primary btn-lg mb-2"
                >
                  <FaArrowLeft className="me-2" />
                  Go Back
                </button>
              </div>
              
              {/* Helpful Links */}
              <div className="helpful-links mt-5">
                <p className="text-muted mb-3">Or try these popular pages:</p>
                <div className="d-flex flex-wrap justify-content-center gap-3">
                  <Link to="/about" className="text-decoration-none">About Us</Link>
                  <Link to="/projects" className="text-decoration-none">Our Projects</Link>
                  <Link to="/contact" className="text-decoration-none">Contact</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;